import ExcelJS from "exceljs";
import axios from "axios";
import Swal from "sweetalert2";

export const uploadExcelForPrintingProductsDimension = async (e) => {
  const file = e?.target?.files[0];
  const formData = new FormData();
  formData.append("file", file);
  const validateExcelData = (data) => {
    let isValid = true;
    let error = "";
    if (!data || data.length === 0) {
      return { isValid: false, error: "No data found in the Excel file." };
    }

    const requiredColumns = [
      "printingProductWidth",
      "printingProductHeight",
      //   "Thickness",
    ];

    if (!data[0]) {
      return {
        isValid: false,
        error: "Excel file is empty or has no valid rows.",
      };
    }

    data.forEach((row, index) => {
      requiredColumns.forEach((field) => {
        if (!row[field] || row[field].toString().trim() === "") {
          isValid = false;
          error = `Missing or invalid value for '${field}' at row ${index + 1
            }.`;
        }
      });
    });

    if (!isValid) {
      return { isValid: false, error };
    }

    return { isValid: true };
  };

  const readExcelFile = async (file) => {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = async (event) => {
        const buffer = event.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer); // Load the Excel file buffer

        const worksheet = workbook.worksheets[0]; // Assuming you want the first sheet
        const rows = [];

        worksheet.eachRow((row, rowNumber) => {
          const rowValues = row.values; // row.values gives an array of cell values
          // Remove the first empty element (ExcelJS starts rows with an empty index)
          rows.push(rowValues.slice(1));
        });

        resolve(rows);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file); // Read the file as an array buffer
    });
  };

  // Convert the Excel sheet into a JSON array
  const processExcelDataToJson = (rows) => {
    const headers = rows[0]; // First row as headers
    const data = rows.slice(1).map((row) => {
      const rowData = {};
      row.forEach((value, index) => {
        rowData[headers[index]] = value;
      });
      return rowData;
    });

    return data; // Return the JSON array
  };

  try {

    const rows = await readExcelFile(file);
    const jsonData = processExcelDataToJson(rows);

    // Validate the Excel data
    const validationResult = validateExcelData(jsonData);
    if (!validationResult.isValid) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error", // Type of alert (error, success, warning, info, question)
        title: "Validation Error",
        text: validationResult.error, // Display the validation error
        confirmButtonText: "OK", // Text for the confirm button
      });
      return;
    }
    const response = await axios.post(

      `${process.env.REACT_APP_URL}/upload-template/createSecondaryProducts`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (response.data.success) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "success", // Type of alert (error, success, warning, info, question)
        text: "File uploaded and data saved successfully.", // Display the validation error
        confirmButtonText: "OK", // Text for the confirm button
      }).then(() => { });
      // window.location.reload();
      return response.data;
    }
  } catch (error) {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      icon: "error", // Type of alert (error, success, warning, info, question)
      title: " There was an error uploading the file.",
      text: error, // Display the validation error
      confirmButtonText: "OK", // Text for the confirm button
    });
  }
};
